import { render, staticRenderFns } from "./CreatePub.vue?vue&type=template&id=15795026&"
import script from "./CreatePub.vue?vue&type=script&lang=js&"
export * from "./CreatePub.vue?vue&type=script&lang=js&"
import style0 from "./CreatePub.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports